import React, { useEffect, useState, useCallback } from "react";
import { useLocation, Link, useParams, useNavigate } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { getSelfcareUrl } from "../config/config";
import LinkWithQuery from "../components/LinkWithQuery";
import { useForm, Controller } from "react-hook-form";
import { content } from "../assets/const/content";
import {
  Grid,
  Box,
  Container,
  Button,
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useTheme,
  useMediaQuery,
  Popover,
  Modal,
  TextField,
  FormHelperText,
  CircularProgress,
  Collapse,
} from "@mui/material";
//utils
import { constructUrl, resolveVenueDisplayData } from "../utils/utils";

import AddCircleIcon from '@mui/icons-material/AddCircle';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import CloseIcon from "@mui/icons-material/Close";
import "../assets/stylesheets/landing.css";
import boingoLogoWhite from "../assets/images/Boingo-Logo-White.svg";
import fiberLogo from "../assets/images/Boingo-Fiber-Logo.svg";
import whyBoingoFiberSubHeader from "../assets/images/why-boingo-fiber-subhead.svg";
import crossedPrice from "../assets/images/crossed-out-price.svg";

import vectorCheck from "../assets/images/vector_checkai.png";
import vectorLeftWhisker from "../assets/images/vector_left_whisker.png";
import vectorRightWhisker from "../assets/images/vector_right_whisker.png";

import signInIcon from "../assets/images/Sign-In-Mobile.svg";
import setUpSubHeader from "../assets/images/setup-in-seconds-savings-subhead.svg";

import worksWithBoingImg from "../assets/images/Works-With-Boingo-Fiber-Sticker.svg";
import horizontalLine from "../assets/images/Footer-Horizontal-Line-Desktop.svg";
import lookForSticker from "../assets/images/Look-For-This-Sticker-With-Arrow.svg";

import priceSticker from "../assets/images/Price-1GB-Violator.svg";

import { ReactComponent as Router } from '../assets/images/Illustration-Router.svg'
import { ReactComponent as EthernetCable } from "../assets/images/Illustration-Ethernet-Cable.svg";
import TPLinkAX10 from "../assets/images/TP-Link-AX-10.jpg"
import TPLinkAX21 from "../assets/images/TP-Link-AX-21.jpg"
import ASUSAX1800 from "../assets/images/ASUS-AX-1800.jpg"
import LinkSysMR7350 from "../assets/images/Linksys-MR-7350.jpg"

import PluginRouterStep from "../assets/images/Illustration-Plug-In-Router.png"
import PhoneSetup from "../assets/images/Illustration-Phone-Setup.png";
import { ReactComponent as NumberOne } from "../assets/images/Number-1-Red.svg";
import { ReactComponent as NumberTwo } from "../assets/images/Number-2-Red.svg";
import { ReactComponent as NumberThree } from "../assets/images/Number-3-Red.svg";

// Import the LoginModal component
import { LoginModal } from "../components/LoginModal";
import { NutritionFacts } from "../components/NutritionFacts";
import { Helmet } from "react-helmet";
import { VenueModal } from "../components/VenueModal";
import { VENUE_SELECTOR_CONST } from "../assets/const/venue-const";
import { getCombinedUrlSearchParams } from "../utils/eventUtils";
import { useVenueData } from "../context/VenueDataContext";

// Navbar component
const Navbar = ({ isHidden }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <Box data-test-id="mobile-nav-drawer">
      <Box className="mobile-nav-container" onClick={handleDrawerToggle}>
        <img src={fiberLogo} />
        <CloseIcon className="close-icon" />
      </Box>

      <Box className="mobile-nav-sub-section" data-test-id="mobile-nav-sub-section">
        <Typography className="lets-start">
          {/* Let&#8217;s start by finding out
          <br /> if Boingo Fiber is available <br /> in your home */}
        </Typography>
        <LinkWithQuery to="/signup-form" className="avail-btn">
          Sign Up Now
        </LinkWithQuery>
      </Box>
      <Box className="mobile-nav-hr"></Box>
      <Box className="mobile-sign-in-wrapper" data-test-id="mobile-sign-in-wrapper">
        <a href={getSelfcareUrl(window.location.host)}>
          <img src={signInIcon} />
          Sign Up
        </a>
      </Box>
    </Box>
  );

  const [loginModalOpen, setLoginModalOpen] = useState(false);

  const handleLoginClick = () => {
    setLoginModalOpen(true);
  };

  const handleLoginClose = () => {
    setLoginModalOpen(false);
  };

  const handleLoginSuccess = useCallback((data) => {
    console.log("Authentication successful", data);
    setLoginModalOpen(true); // Close the modal

    // Use setTimeout to delay the navigation
    setTimeout(() => {
      const currentHash = window.location.hash.split("?")[0]; // Keep the '#' but remove query params
      const basePath = currentHash.split("/")[1]; // Get the second part of the path (e.g., 'afmthm')
      const newPath = `#/${basePath}/welcome`;
      window.location.hash = newPath;
    }, 2000);
  }, []);

  return (
    <Box data-test-id="nav-container">
      <AppBar
        position="fixed"
        className="app-bar"
        sx={{
          backgroundColor: "rgb(44, 46, 55)",
          transition: "transform 0.3s ease-in-out",
          transform: isHidden ? "translateY(-100%)" : "translateY(0)",
        }}
      >
        <Toolbar>
          {isMobile ? (
            <>
              {/* Mobile Navigation */}
              <Box
                className="mobile-nav"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  padding: "0 4px",
                }}
                data-test-id="mobile-nav"
              >
                <Box
                >
                  <img
                    src={boingoLogoWhite}
                    style={{ minWidth: "70px" }}
                  />
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "auto",
                    gap: 1,
                    minWidth: 0, // Allow this container to shrink
                  }}
                >
                  <VenueSelector
                    type="mobile-nav"
                    onClick={handleLoginClick}
                    customStyles={{
                      button: {
                        fontSize: "16px",
                        color: "rgba(255, 255, 255, 1)",
                        whiteSpace: "nowrap",
                        border: "1px solid rgba(255, 255, 255, 0.4)",
                        borderRadius: "8px",
                        padding: "0px 14px",
                        "&:hover": {
                          background: "var(--greyBg)",
                          border: "1px solid white",
                          transition: "all .3s ease-in-out",
                        },
                      },
                      a: {
                        color: "#FFF",
                        fontSize: "16px",
                        whiteSpace: "nowrap",
                      },
                    }}
                  />
                </Box>
                <Drawer
                  variant="temporary"
                  open={mobileOpen}
                  anchor="right"
                  onClose={handleDrawerToggle}
                  ModalProps={{ keepMounted: true }}
                >
                  {drawer}
                </Drawer>
              </Box>
            </>
          ) : (
            <Container
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "75%",
                flexFlow: "row",
                "&.MuiContainer-root": { maxWidth: "1500px" },
              }}
            >
              <Grid
                sx={{
                  width: "auto",
                  alignSelf: "flex-start",
                }}
              >
                <Grid
                  item
                  sx={{
                    textAlign: "right",
                    width: "300px",
                    display: "flex",
                    justifyContent: "flex-start",
                  }}
                >
                  <Box sx={{ width: "30%", mt: 1 }}>
                    <img src={boingoLogoWhite} className="footer-logo" />
                  </Box>
                </Grid>
              </Grid>
              <Grid
                sx={{
                  justifyContent: "flex-end",
                  display: "flex",
                }}
              >
                <Grid
                  sx={{
                    display: "flex",
                    width: "auto",
                    flexFlow: "row",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    gap: 3,
                  }}
                >
                  <VenueSelector
                    type="nav"
                    onClick={handleLoginClick}
                    customStyles={{
                      button: {
                        fontSize: "16px",
                        border: "1px solid rgba(255, 255, 255, 0.4)",
                        borderRadius: "8px",
                        padding: "2px 24px",
                        color: "rgba(255, 255, 255, 1)",
                        ":hover": {
                          backgroundColor: "#000",
                        },
                      },
                      a: {
                        color: "#FFF",
                        whiteSpace: "nowrap",
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </Container>
          )}
        </Toolbar>
      </AppBar>
      <Toolbar /> {/* Offset for content */}
      {/* Login Modal */}
      <LoginModal
        open={loginModalOpen}
        onClose={handleLoginClose}
        onLoginSuccess={handleLoginSuccess}
      />
    </Box>
  );
};

const HeroSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  
  return (
    <>
      <Box
        className="hero-section"
        data-test-id="hero-section-container"
      >
        <Box className="hero-img" ></Box>
      </Box>
    </>
  )
};

// PlansSection component
const PlansSection = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const theme = useTheme();

  const handlePopOverClick = (event) => {
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  // Use Grid for layout of plans
  return (
    <Box className="plan-section" data-test-id="plan-section-container">
      <Typography 
        className="sub-title" 
        data-test-id="landing-page-subtitle-wrapper"
      >
        Just bring your own router and get in the fast lane!
      </Typography>
    </Box>
  );
};

const VenueSelector = ({customStyles, type, className, onClick}) => {
  const [venueModalOpen, setVenueModalOpen] = useState(false);
  const [error, setError] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const location = useLocation();
  const navigate = useNavigate();
  const { venues, loading: venuesLoading, error: venuesError } = useVenueData();

  const handleClick = () => {
    if (venuesLoading) {
      setError(VENUE_SELECTOR_CONST.loading_venues);
      setVenueModalOpen(true);
      return;
    }
    if (venuesError || Object.keys(venues || {}).length === 0) {
      setError(venuesError || VENUE_SELECTOR_CONST.load_error);
      setVenueModalOpen(true);
      return;
    }

    const path = location.pathname;
    const pathParts = path.split("/").filter(Boolean);
    const venue = pathParts.shift();
    const validVenue = venue && Object.keys(venues).findIndex(v => (v.toLowerCase() === venue.toLowerCase()))
    // Verify its a valid venue 
    if (venue && validVenue !== -1) {
      // navigate to the signup form 
      const signupUrl = constructUrl('/signup-form', venue, location.search)
      navigate(signupUrl);
    } else {
      // otherwise, if invalid venue code or no venue in the URL 
      // open the venue dropdown menu 
      (venue && validVenue === -1) && setError(VENUE_SELECTOR_CONST.invalid_venue);
      setVenueModalOpen(true);
    }
  }

  return (
    <>
      <Button
        type={!type ? "submit" : type !== "submit" ? type : ""}
        className={`${className} ${type === 'nav' || type === 'mobile-nav' && 'mobile-nav-btn'}` ?? "avail-btn large"}
        data-test-id="sign-up-btn"
        onClick={() => handleClick()}
        sx={customStyles?.button}
      >
        {isMobile
          ? VENUE_SELECTOR_CONST.signup_mobile
          : VENUE_SELECTOR_CONST.signup_desktop}
      </Button>
      { (type === "nav" || type === "mobile-nav") &&
          <Box
            className="mobile-nav-link"
            style={customStyles?.a}
            onClick={onClick}
          >
            <span style={{ marginRight: 4, ...customStyles?.span }}>{ isMobile ? "Have an account?" : "Already have an account?"}</span>
            <button 
              style={{ 
                background: "transparent",
                fontSize: "16px",
                fontFamily: "Figtree-Regular",
                color: "#FFF",
                border: "none",
                cursor: "pointer",
                textDecoration: "underline", 
                ...customStyles?.span 
              }}
            >Log in</button>
          </Box>
      }
      <VenueModal
        error={error}
        open={venueModalOpen}
        onClose={() => setVenueModalOpen(false)} 
      />
    </>
  );
}

// FeaturesSection component
const FeaturesSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { venueId } = useParams();
  const { venues } = useVenueData();
  const venueData = resolveVenueDisplayData(venueId, venues);

  const [expandedSetup, setExpandedSetup] = useState(false);
  const [expandedWhatYoullNeed, setExpandedWhatYoullNeed] = useState(false);

  const [] = useState(false);

  return (
    <>
      <Box className="feature-section" data-test-id="feature-section-container">
        {/* <pre>{JSON.stringify(venueId)}</pre> */}
        <Container>
          <Box
            className={`
              plan-container
              ${venueId !== "afmthm" && 
              "no-discount"}
            `}
          >
            <Box
              className={`
                plan-wrap 
                ${venueId !== "afmthm" && 
                "no-discount"}
              `}
            >
              <Typography className="plan-title">
                {venueData?.plan_name}
              </Typography>
              <Box className="description-wrap">
                {venueData?.promo?.promo_title && (
                  <Box className="desc-row">
                    <Typography className="description">
                      <img className="whisker" src={vectorLeftWhisker} />
                      {venueData?.promo?.promo_title}
                      <img className="whisker" src={vectorRightWhisker} />
                    </Typography>
                  </Box>
                )}
                <Box className="desc-row">
                  <Box className="price-wrapper" sx={{ marginBottom: isMobile ? "-32px" : ""}}>
                    {venueData?.promo && (
                      <img className="crossed-price" src={crossedPrice} />
                    )}
                    <Typography className="price">
                      <span className="dollar-sign">$</span>
                      {venueData?.promo?.promo_price || venueData?.plan_price}
                      <span className="duration">/mo</span>
                    </Typography>
                  </Box>
                </Box>
                <Box>
                  <ul
                    className={`plan-details-list ${
                      venueId !== "afmthm" && "no-discount"
                    }`}
                  >
                    {(venueData?.module_content?.plan_list_text || []).map((text, index) => (
                      <li key={index}>
                        <img className="check" src={vectorCheck} />
                        <span>{text}</span>
                      </li>
                    ))}
                  </ul>
                </Box>
                <VenueSelector 
                  customStyles={{
                    button: {
                      padding: "10px 60px",
                      borderRadius: "7px",
                    }
                  }} 
                />
              </Box>
            </Box>
          </Box>

          <Box data-test-id="content-container">
            <Box className="landing-content-wrapper">
              <Typography 
                variant="h4" 
                fontFamily="Figtree-Bold" 
                className="content-section-header"
                  sx={{
                    paddingTop: isMobile ? "0px" : "",
                  }}
              >
                {content.whatYoullNeedText}
              </Typography>
              <Box
                className="gw-item wifi"
                sx={{
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row",
                  width: "60%",
                  padding: 0,
                  mx: "40px",
                }}
                data-test-id="what-youll-need-images"
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexDirection: "column",
                    fontSize: "12px",
                    height: "100%",
                    width: "100%",
                  }}
                >
                  <Router
                    style={{
                      height: "110px",
                      maxWidth: "150px",
                      width: "auto",
                    }}
                  />
                  <Typography fontFamily={["Figtree-Bold"]} mt={2}>
                    Router
                  </Typography>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexDirection: "column",
                    fontSize: "12px",
                    height: "100%",
                    width: "100%",
                  }}
                >
                  <EthernetCable
                    style={{
                      height: "90px",
                      maxWidth: "100px",
                      width: "auto",
                      marginTop: "30px",
                    }}
                  />
                  <Typography fontFamily={["Figtree-Bold"]} mt="16px">
                    An ethernet cable
                  </Typography>
                </Box>
              </Box>
              <Box>
              <Box
                sx={{
                  margin: isMobile ? "0 auto" : "48px auto 0",
                  textAlign: "center",
                  width: "100%",
                  padding: isMobile ? "0 14px" : "auto",
                  textAlign: "center",
                  lineHeight: "1.1",
                }}
              >
                <Typography
                  sx={{ margin: isMobile ? "30px 0 18px 0" : "-20px 0 18px 0" }}
                >
                  A router allows your modem’s internet signal to connect
                  wirelessly to devices throughout your room.
                </Typography>
                <button
                  type="button"
                  className="expand-btn"
                  data-track-label="landing-learn-more-router"
                  onClick={() =>
                    setExpandedWhatYoullNeed(!expandedWhatYoullNeed)
                  }
                  style={{
                    border: "none",
                    background: "transparent",
                    padding: 0,
                    cursor: "pointer",
                    color: "inherit",
                    font: "inherit",
                  }}
                >
                  <Typography className="learn-more" component="span">
                    Learn More
                  </Typography>
                  <Box
                    component="span"
                    sx={{
                      position: 'relative',
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: 'rgba(77, 79, 87, 1)', 
                      border: '1px solid black',
                      borderRadius: '50%', 
                      p: 0.5, 
                      ml: 1
                    }}
                  >
                  {expandedWhatYoullNeed ? (
                    <RemoveCircleIcon 
                      sx={{
                        height: "1.5rem", 
                        width: "auto", 
                        position: 'absolute', 
                        color: "rgba(235, 234, 236, 1)", 
                        fontSize: 'inherit' 
                      }} 
                    />
                  ) : (
                    <AddCircleIcon 
                      sx={{ 
                        height: "1.5rem", 
                        width: "auto", 
                        position: 'absolute', 
                        color: "rgba(235, 234, 236, 1)", 
                        fontSize: 'inherit' 
                      }} 
                    />
                    )}
                  </Box>
                </button>
                <Collapse in={expandedWhatYoullNeed} timeout="auto">
                  <Box mt={2}>
                    <RouterImagesSection />
                    <Box className="gw-item additional" sx={{ mt: "10px" }}>
                      <Typography mt={3}>
                        We have stress tested these systems in our labs.
                        Already have a router you love? Just make sure it
                        meets these specs:
                      </Typography>
                    </Box>

                    <ul className={`router-specs-list`} style={{ textAlign: "left", listStyleType: 'none'}}>
                        {(venueData?.module_content?.router_specs_list_text || []).map(
                          (text, index) => (
                            <li key={index}>
                              <img className="check" src={vectorCheck} />
                              <span>{text}</span>
                            </li>
                          )
                        )}
                      </ul>
                  </Box>
                </Collapse>
              </Box>

              <Box
                className=""
                sx={{
                  margin: isMobile ? "0 auto" : "48px auto 0",
                  textAlign: "center",
                  // width: isMobile ?  "95%" : "auto",
                  padding: isMobile ? "0 14px" : "auto",
                  textAlign: "center",
                  lineHeight: "1.1",
                }}
              >
                <Typography 
                  variant="h4" 
                  fontFamily="Figtree-Bold" 
                  className="content-section-header"
                  sx={{}}
                >
                  Set up is as easy as 1-2-3
                </Typography>
                <Typography
                  sx={{ margin: isMobile ? "10px 0 18px 0" : "18px 0" }}
                >
                  Just plug in your router, follow the set up instructions
                  that came with it, and open a browser.
                  <br />
                  You'll be automatically directed to the Boingo Fiber login
                  page.
                </Typography>
                <button
                  type="button"
                  className="expand-btn"
                  data-track-label="landing-learn-more-setup"
                  onClick={() => setExpandedSetup(!expandedSetup)}
                  style={{
                    border: "none",
                    background: "transparent",
                    padding: 0,
                    cursor: "pointer",
                    color: "inherit",
                    font: "inherit",
                  }}
                >
                  <Typography className="learn-more" component="span">
                    Learn More
                  </Typography>
                  <Box
                    component="span"
                    sx={{
                      position: 'relative',
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: 'rgba(77, 79, 87, 1)', 
                      border: '1px solid black',
                      borderRadius: '50%', 
                      p: 0.5, 
                      ml: 1,
                    }}
                  >
                  {expandedSetup ? (
                    <RemoveCircleIcon
                      sx={{ height: "1.5rem", width: "auto", position: 'absolute', color: "rgba(235, 234, 236, 1)", fontSize: 'inherit' }}
                    />
                  ) : (
                    <AddCircleIcon
                      sx={{ height: "1.5rem", width: "auto", position: 'absolute', color: "rgba(235, 234, 236, 1)", fontSize: 'inherit' }}
                    />
                  )}
                  </Box>
                </button>
                <Collapse in={expandedSetup} timeout="auto">
                  <SetupStepsSection />
                </Collapse>
              </Box>
              <Box my={isMobile ? 4 : 8}>
                <VenueSelector 
                  customStyles={{
                    button: {
                      padding: "10px 60px",
                      borderRadius: "7px",
                    }
                  }}
                />
              </Box>
              </Box>
            </Box>
          </Box>
        </Container>
      </Box>
    </>
  );
};

const SetupStepsSection = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      <Box 
        sx={{
          '& .MuiTypography-root': {
            fontSize: '16px', 
          },
        }}
        className="setup-steps-section"
        data-test-id="setup-steps-section"
      >
        <Container
          sx={{
            '& .MuiContainer-root': {
              padding: "0",
              margin: "0",
            }
          }}
        >
          <Box 
            // className='setup-steps-images'
            sx={{ 
              display: 'flex',
              flexDirection: 'row',
              justifyContent: "center",
              alignItems: 'center',
              width: "80%",
              margin: isMobile ?  "26px auto 28px" : "30px auto 40px",
            }} 
          >
              <img 
              src={PluginRouterStep} 
                style={{
                  width: isMobile ? "180px" : "210px",
                  height: "auto"
                }} 
              />
              <img 
              src={PhoneSetup} 
                style={{
                  width: isMobile ? "100px" : "120px",
                  marginLeft: "22px",
                  height: "auto"
                }} 
              />
          </Box>

          <Box className="steps-container" data-test-id="steps-container">
            <Box className="step">
              <Box className="step-img">
                <NumberOne />
              </Box>
              <Typography className="step-content">{content.routerSteps.one}</Typography>
            </Box>
            <Box className="step">
              <Box className="step-img">
                  <NumberTwo />
              </Box>
              <Typography className="step-content">{content.routerSteps.two}</Typography>
            </Box>
            <Box className="step">
              <Box className="step-img">
                  <NumberThree />
              </Box>
              <Typography className="step-content">{content.routerSteps.three}</Typography>
            </Box>
          </Box>
        </Container>
      </Box>
    </>
  );
};

const RouterImagesSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box className="router-images">
      <Box 
        sx={{
          display: "flex", 
          flexDirection: "row", 
          justifyContent: "space-between",
        }}
      >
        <Box ml="-8px">
          <img className="router-img" src={TPLinkAX10} />
          <Typography fontFamily={"Figtree-Bold"}>TP-Link AX10</Typography>
        </Box>

        <Box>
          <img className="router-img" src={TPLinkAX21} />
          <Typography fontFamily={"Figtree-Bold"}>TP-Link AX21</Typography>
        </Box>
      </Box>

      <Box sx={{ 
        display: "flex", 
        flexDirection: "row", 
        justifyContent: "space-between",
      }}>
        <Box ml="-8px">
          <img className="router-img" src={ASUSAX1800} />
          <Typography fontFamily={"Figtree-Bold"}>ASUS AX1800</Typography>
        </Box>
        <Box>
          <img className="router-img" src={LinkSysMR7350} />
          <Typography fontFamily={"Figtree-Bold"}>Linksys MR7350</Typography>
        </Box>
      </Box>

    </Box>
  );
};

// Footer component
const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <Box
        className="landing-page-footer-section"
        data-test-id="landing-page-footer-section"
        sx={{ backgroundColor: "rgb(44, 46, 55)" }}
      >
          <img src={boingoLogoWhite} className="footer-logo" alt="logo" />

          <Box className="footer-links-wrapper">
            <Box className="footer-links">
              <Link
                to="https://www.boingo.com/legal/boingo-privacy-policy/"
                target="_blank"
                data-test-id="landing-page-privacy-link"
              >
                Privacy policy
              </Link>{" "}
              <span style={{ color: "rgba(175, 177, 181, 0.9)" }}>&nbsp;|&nbsp;&nbsp;</span>
              <Link
                target="_blank"
                to="https://www.boingo.com/legal/website-terms-use-acceptable-use-policy/"
                data-test-id="landing-page-terms-link"
              >
                Terms of use
              </Link>{" "}
              <span style={{ color: "rgba(175, 177, 181, 0.9)" }}>&nbsp;|&nbsp;&nbsp;</span>
              <Link
                target="_blank"
                to="https://www.boingo.com/legal/cookie-policy/"
                data-test-id="landing-page-cookie-link"
              >
                Cookie policy
              </Link>
            </Box>

            <Typography color="rgba(175, 177, 181, 0.9)">
              Boingo customer support is available 24/7/365.
            </Typography>

            <Typography color="rgba(175, 177, 181, 0.9)" data-test-id="landing-page-copyright">
              &copy; {currentYear} Boingo Wireless, Inc. All rights reserved.
            </Typography>
          </Box>
      </Box>
    </>
  );
};

const FixedSignUpForm = ({ show }) => {
  return (
    <>
      <Box
        className="fixed-signup-form"
        sx={{
          padding: "18px 0px",
          transition: "transform 0.5s ease-in-out, opacity 0.5s ease-in-out",
          transform: show ? "translateY(0)" : "translateY(100%)",
          opacity: show ? 1 : 0,
          pointerEvents: show ? "auto" : "none",
        }}>
        <VenueSelector 
          customStyles={{ 
            button: {
              width: "90%", 
              padding: "10px !important",
              fontSize: "18px !important"
            }
          }}  
        />
      </Box>
    </>
  );
};

const LandingPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [showFixedFooter, setShowFixedFooter] = useState(false);
  const [isNavHidden, setIsNavHidden] = useState(false);
  const showFixedFooterRef = React.useRef(showFixedFooter);
  showFixedFooterRef.current = showFixedFooter;

  const handleScroll = useCallback(() => {
    const bottomReached = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 300;
    const shouldShow = window.scrollY > 100 && !bottomReached;

    if (shouldShow !== showFixedFooterRef.current) {
      setShowFixedFooter(shouldShow);
      setIsNavHidden(shouldShow);
    }
  }, []);

  useEffect(() => {
    if (isMobile) {
      const throttledHandleScroll = () => {
        requestAnimationFrame(handleScroll);
      };
      window.addEventListener("scroll", throttledHandleScroll, { passive: true });
      return () => window.removeEventListener("scroll", throttledHandleScroll);
    } else {
      setShowFixedFooter(false);
      setIsNavHidden(false);
    }
  }, [isMobile, handleScroll]);

  return (
    <Box 
      sx={{
        textAlign: "center",
        overflowX: "hidden"
      }} 
      className="landing-page-container"
      data-test-id="landing-page-container"
    >
      <Helmet>
        <title>Boingo Ethernet - Home</title>
      </Helmet>
      <Navbar isHidden={isNavHidden} />
      <HeroSection />
      <PlansSection />
      <FeaturesSection />
      <Footer />
      {isMobile && <FixedSignUpForm show={showFixedFooter} />}
    </Box>
  );
};

export default LandingPage;
